import { Button, Input, Textarea, useToast } from "@chakra-ui/react";
import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { useOnAPISuccess } from "../api/useOnAPISuccess";
import { useToastOnAPIError } from "../api/useToastOnAPIError";
import { AppPage } from "../utils/AppPage";
import { TeamSelector } from "../utils/TeamSelector";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { isParamNumeric } from "../utils/utils";

export const AwardPage = () => {
  const api = useAPI();
  const [awardAmount, setAwardAmount] = useState("");
  const [teamId, setTeamId] = useState("");
  const [note, setNote] = useState("");
  const { data, state, query, error } = useAPIQuery<"teamPointPost">({
    apiCall: api.teamPointPost,
  });
  const navigate = useNavigate();
  const toast = useToast();
  useToastOnAPIError({ title: "Unable to award point", error });
  useOnAPISuccess<"teamPointPost">({
    data,
    state,
    onSuccess: () => {
      toast({ status: "success", title: "Award Successful", position: "top" });
      navigate("/leaderboard");
    },
  });

  const isValid = useMemo(
    () => isParamNumeric(teamId) && isParamNumeric(awardAmount),
    [awardAmount, teamId]
  );

  const onAward = useCallback(() => {
    if (!isValid || state === "loading") {
      return;
    }
    query({
      value: Number(awardAmount),
      teamId: Number(teamId),
      note: note.length > 0 ? note : undefined,
    });
  }, [awardAmount, isValid, note, query, state, teamId]);

  return (
    <AppPage title={"Award Points"}>
      <Input
        value={awardAmount}
        onChange={(e) => setAwardAmount(e.target.value)}
        type={"number"}
        placeholder={"Points to award"}
        marginTop={4}
        marginBottom={4}
      />
      <TeamSelector value={teamId} setValue={setTeamId} />
      <Textarea
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Note"
        size={"lg"}
        marginTop={4}
      />
      <Button
        isDisabled={!isValid}
        colorScheme={THEME_COLOR_SCHEME}
        width={"100%"}
        marginTop={4}
        onClick={onAward}
        isLoading={state === "loading"}
      >
        Award
      </Button>
    </AppPage>
  );
};
